<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  modelValue: { type: String, default: '' },
  savedVariables: { type: Array, default: () => [] },
});
const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();
const selectedVariable = ref('');

const variables = computed(() => [
  'contact.name',
  'contact.email',
  'contact.phone_number',
  'conversation.display_id',
  'assignee.name',
  ...props.savedVariables,
]);

const insertVariable = () => {
  if (!selectedVariable.value) return;
  emit(
    'update:modelValue',
    `${props.modelValue}${props.modelValue ? ' ' : ''}{{${selectedVariable.value}}}`
  );
  selectedVariable.value = '';
};
</script>

<template>
  <div class="flex items-center gap-2">
    <select
      v-model="selectedVariable"
      class="flex-1 mb-0 text-xs"
      :aria-label="t('TELETEL_FLOWS.BUILDER.VARIABLE_PICKER_LABEL')"
      @change="insertVariable"
    >
      <option value="">
        {{ t('TELETEL_FLOWS.BUILDER.VARIABLE_PICKER_LABEL') }}
      </option>
      <option v-for="variable in variables" :key="variable" :value="variable">
        {{ '{' + '{' + variable + '}' + '}' }}
      </option>
    </select>
  </div>
</template>
